<template>
  <div class="dictionary">
    <el-alert
      title="请勿删除选项或修改编码，否则会影响历史信息。这里仅允许调整名称、排序和启停；停用后不再供新发布选择。新版历史记录保留发布时文案，旧记录可能仍按当前字典显示。"
      type="warning"
      :closable="false"
    />
    <div class="filters">
      <el-select
        v-model="module"
        placeholder="业务模块"
        @change="
          group = '';
          items = [];
        "
        ><el-option
          v-for="name in modules"
          :key="name"
          :label="name"
          :value="name" /></el-select
      ><el-select
        v-model="group"
        filterable
        placeholder="选择字典"
        @change="load"
        ><el-option
          v-for="item in filteredGroups"
          :key="item.main_key"
          :value="item.main_key"
          :label="item.name + ' (' + item.main_key + ')'" /></el-select
      ><el-button @click="load">刷新</el-button>
    </div>
    <el-table :data="items" v-loading="loading"
      ><el-table-column
        prop="enum_key"
        label="固定编码"
        min-width="150"
      /><el-table-column
        prop="enum_value"
        label="名称"
        min-width="150"
      /><el-table-column prop="sort" label="排序" width="100" /><el-table-column
        label="状态"
        width="90"
        ><template slot-scope="s">{{
          Number(s.row.status) === 1 ? "启用" : "停用"
        }}</template></el-table-column
      ><el-table-column label="操作" width="100"
        ><template slot-scope="s"
          ><el-button
            v-auth="'/operations/dictionary/edit'"
            type="text"
            @click="open(s.row)"
            >编辑</el-button
          ></template
        ></el-table-column
      ></el-table
    >
    <el-dialog
      title="编辑字典选项"
      :visible.sync="visible"
      width="500px"
      :close-on-click-modal="false"
      ><el-form label-width="90px" :disabled="saving"
        ><el-form-item label="固定编码">{{ form.enum_key }}</el-form-item
        ><el-form-item label="名称"
          ><el-input v-model="form.enum_value" maxlength="80" /></el-form-item
        ><el-form-item label="排序"
          ><el-input-number
            v-model="form.sort"
            :min="0"
            :max="999999"
            :precision="0" /></el-form-item
        ><el-form-item label="启用"
          ><el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0" /></el-form-item></el-form
      ><span slot="footer"
        ><el-button :disabled="saving" @click="visible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="save"
          >保存</el-button
        ></span
      ></el-dialog
    >
  </div>
</template>
<script>
import { _get, _post } from "@/utils/request";
export default {
  data() {
    return {
      groups: [],
      items: [],
      module: "变现",
      group: "",
      loading: false,
      serial: 0,
      visible: false,
      saving: false,
      form: {},
    };
  },
  computed: {
    modules() {
      return Array.from(new Set(this.groups.map((item) => item.module)));
    },
    filteredGroups() {
      return this.groups.filter((item) => item.module === this.module);
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      const serial = ++this.serial;
      this.loading = true;
      this.items = [];
      try {
        const res = await _get("/shop/operations.dictionary/index", {
          group: this.group,
        });
        if (serial !== this.serial) return;
        this.groups = res.data.groups;
        this.items = res.data.items;
      } catch (e) {
      } finally {
        if (serial === this.serial) this.loading = false;
      }
    },
    open(row) {
      this.form = Object.assign({}, row, {
        sort: Number(row.sort),
        status: Number(row.status),
      });
      this.visible = true;
    },
    async save() {
      if (this.saving) return;
      this.saving = true;
      try {
        const { id, version, enum_value, sort, status } = this.form;
        await _post("/shop/operations.dictionary/edit", {
          id,
          version,
          enum_value,
          sort,
          status,
        });
        this.visible = false;
        this.$message.success("已保存");
        await this.load();
      } catch (e) {
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
<style scoped>
.dictionary {
  padding: 20px;
  background: #fff;
}
.filters {
  margin: 20px 0;
  display: flex;
  gap: 12px;
}
.filters .el-select:nth-child(2) {
  width: 420px;
}
</style>



// WEBPACK FOOTER //
// src/views/operations/dictionary/index.vue